import { gql } from "@apollo/client";

const YRH_COMMENT_FIELDS = `
  id
  parentId
  authorId
  domain
  isPrivate
  data
  ref {
    collection
    id
  }
  createdAt
  updatedAt
`;

export const CREATE_YRH_COMMENT = gql`
  mutation CreateYrhComment($input: CreateYrhCommentInput!) {
    createYrhComment(input: $input) {
      yrhComment {
        ${YRH_COMMENT_FIELDS}
      }
    }
  }
`;

export const UPDATE_YRH_COMMENT = gql`
  mutation UpdateYrhComment($input: UpdateYrhCommentInput!) {
    updateYrhComment(input: $input) {
      yrhComment {
        ${YRH_COMMENT_FIELDS}
      }
    }
  }
`;

export const DELETE_YRH_COMMENT = gql`
  mutation DeleteYrhComment($id: ID!) {
    deleteYrhComment(id: $id) {
      id
    }
  }
`;
